<template>
  <v-container
    id="view-endpoint-meter"
    fluid
    v-if="loaded"
  >
    <v-row>
      <v-col cols="12">
        <Breadcrumb :items="items" ></Breadcrumb>
        <h1>
          <v-icon
            right
            :color="supplyIcon"
            x-large
            v-if="isSupply"
            class="supplyIcon"
          >
            mdi-checkbox-blank-circle
          </v-icon>
          {{ meterData.name }}
        </h1>
      </v-col>

    </v-row>

    <v-row>
      <v-col cols="12" class="endpoint-overview">
        <v-row>
          <v-col
            cols="12"
            md="6"
            lg="3"
          >
            <v-card
              color="#5d3791"
              dark
            >
              <v-card-subtitle>Serial</v-card-subtitle>

              <v-card-title class="text-h5">
                {{ meterData.serial }} <div v-if="meterData.alias" style="padding-left: 10px; color: #ccc; font-size: 1.1rem;"> [{{ meterData.alias }}]</div>
              </v-card-title>

            </v-card>
          </v-col>

          <v-col
            cols="12"
            md="6"
            lg="3"
          >
            <v-card
              color="#5d3791"
              dark
            >
              <v-card-subtitle>Unit</v-card-subtitle>

              <v-card-title class="text-h5">
                {{ meterData.unit }}
              </v-card-title>



            </v-card>
          </v-col>

          <v-col
            cols="12"
            md="6"
            lg="3"
          >
            <v-card
              v-if="meterData.balance_data"
              dark
            >
              <v-card-subtitle>Current Balance</v-card-subtitle>

              <v-card-title class="text-h5">
                £{{ meterData.balance_data.balance }}
                <span class="updated-date">Updated {{ meterData.balance_data.read_at }}</span>
              </v-card-title>



            </v-card>

            <v-card
              v-else
              dark
            >
              <v-card-subtitle>Total Reads</v-card-subtitle>

              <v-card-title class="text-h5">
                {{ meterData.total_reads }}
              </v-card-title>



            </v-card>
          </v-col>

          <v-col
            cols="12"
            md="6"
            lg="3"
          >
            <v-card

              dark
            >
              <v-card-subtitle>Last Feed</v-card-subtitle>

              <v-card-title class="text-h5 smaller">
                <span v-if="meterData.last_feed">{{ formatterDate(meterData.last_feed) }}</span>
                <span v-else>-</span>
              </v-card-title>



            </v-card>
          </v-col>


        </v-row>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <h2>Meter Reads</h2>

      </v-col>

    </v-row>

    <v-row>
      <v-col cols="12">
        <v-sheet
          color="white"
          elevation="1"
          class="pa-5"
        >
          <div class="chart" ref="chartdiv"></div>
        </v-sheet>

      </v-col>
    </v-row>

    <v-row>

      <v-col cols="12">
        <v-card>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>

          <v-data-table
            :headers="headers"
            :items="readData"
            :search="search"
            :footer-props="listSize"
            item-key="name"
            class="elevation-1"
          >
            <template #item.readDate="{ value }">
              <span>{{ formatterDate(value) }}</span>
            </template>
            <template #item.last_processed_at="{ value }">
              <span>{{ formatterDate(value) }}</span>
            </template>
            <template #item.id="{ value }">

              <router-link
                custom v-slot="{ navigate }"
                :to="`/metering-data/${id}/meter/${value}`"
              >
                <button @click="navigate" role="link">
                  <v-icon
                    right
                  >
                    mdi-arrow-right-bold
                  </v-icon>
                </button>
              </router-link
              >
            </template>
          </v-data-table>

          <v-alert
            v-if="meterData.total_reads >= maxReads"
            type="info"
            class="warn"
            prominent
            border="left"
          >
            <strong>Displaying Most Recent Read Data</strong>
            <p>Displaying most recent {{maxReads}} reads. Additional reads can be accessed via <router-link style="color: white;"
              :to="`/metering-data/${id}`"
            >meter data export</router-link> </p>
          </v-alert>
        </v-card>
      </v-col>
    </v-row>
    <ConfirmDialog ref="confirm"></ConfirmDialog>
  </v-container>
</template>

<script>
import {get} from "vuex-pathify";
import Breadcrumb from "@/components/Breadcrumb";
import ConfirmDialog from "@/components/ConfirmDialog";
import {date} from "@/mixins/date";

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";

export default {
  name: "EndpointMeter",
  props: {
    id: String,
    meter: String
  },
  components: {
    Breadcrumb,
    ConfirmDialog
  },
  mixins: [date],
  metaInfo () {
    return {
      title: "Meter"
    }
  },
  computed: {
    meterData: get('endpoints/meter'),
    meterRef: get('endpoints/meterRef'),
    isSupply() {
      return this.meterData.endpoint_supply && this.meterData.supply_data.isSupply;
    },
    supplyIcon() {
      return this.meterData.supply_data.enabled ? "#4CAF50" : "#F44336";
    },
    items() {
      return [
        {
          text: 'Metering Data Overview',
          disabled: false,
          exact: true,
          to: '/metering-data',
        },
        {
          text: this.meterData.endpoint_name,
          disabled: false,
          exact: true,
          to: '/metering-data/' + this.id,
        },
        {
          text: this.meterData.name,
          disabled: true,
        }
      ];
    }
  },
  created() {
    this.$store.dispatch("loader/loaderCancel");
    this.fetchData();
  },
  data: () => ({
    maxReads: 2000,
    loaded: false,
    search: '',
    chart: null,
    listSize: {
      "items-per-page-options": [10, 25, 50, 100]
    },
    readData: [],
    headers: [],
    graphs: [],
    seriesData: [{
      name: 'Reads',
      type: 'area',
      data: []
    },{
      name: 'Consumption',
      type: 'area',
      data: []
    }],
    optionData: {
      tooltip: {
        x: {
          format: "dd MMM yyyy",
          formatter: (value) => {
            const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            const date = new Date(value);
            return date.getDate() + " " + monthNames[date.getMonth()];
          }
        }
      },
      chart: {
        height: 600,
        id: 'item',
        group: 'meter',
        type: 'area',
        zoom: {
          enabled: true
        }
      },
      colors: ['#83C45D', '#5d3791'],
      stroke: {
        curve: "smooth",
        width: [0, 0]
      },
      markers: {
        size: 0
      },
      title: {
        text: 'Last 7 Day Reads/Errors'
      },
      dataLabels: {
        enabled: false,
      },
      labels: [],
      xaxis: {
        type: 'datetime',
        min: 0,
        max: 0,
        tickAmount: 8,
      },
      yaxis: [
        {
          title: {
            text: 'Reads',
          },
          labels: {
            minWidth: 10,
            formatter: function(val) {
              return val.toFixed(0);
            }
          }
        },
        {
          opposite: true,
          title: {
            text: 'Consumption'
          },
          labels: {
            formatter: function(val) {
              return val.toFixed(0);
            }
          }
        }
      ]
    }
  }),
  methods: {
    async fetchData() {
      await this.$store.dispatch("loader/loaderInitiate", { title: "Loading Meter" });

      const success = await this.$store.dispatch("endpoints/getEndpointMeter", { endpointRef: this.id, meterRef: this.meter});
      if (!success) {
        await this.$router.push("/metering-data/" + this.id);
        return;
      }

      this.loaded = true;

      await this.$store.dispatch("loader/loaderCancel");

      this.populateFields();


      this.loadGraph();

    },
    formatterDate(value) {
      if (!value) {
        return "";
      }
      return this.formatDateTimezone(value);
    },
    populateFields() {
      let fields = [];
      let fieldMap = {};
      let fieldMapCount = {};
      let newGraphs = {};
      let graphDates = [];

      fields.push({ value: "readDate", text: "Read Date", align: 'start' });
      fields.push({
        value: "read",
        text: this.meterData.unit
      });
      newGraphs["read"] = {
        name: 'Reads',
        type: 'line',
        data: []
      };
      fields.push({
        value: "consumption",
        text: "Consumption"
      });
      newGraphs["consumption"] = {
        name: 'Consumption',
        type: 'line',
        data: []
      };

      let item = 1;
      Object.keys(this.meterData.keys).forEach((key) => {
        const name = this.meterData.keys[key];
        fields.push({ value: "slot" + key, text: name });
        fieldMap[key] = "slot" + key;
        fieldMapCount["slot" + key] = 0;
        item = item + 1;
      });

      fields.push({ value: "extra", text: "", sortable: false });

      let data = [];

      let previousRead = "";

      let originData = this.meterData.reads.reverse();

      originData.forEach((item) => {
        let read = {};

        read.readDate = item.readDate;
        read.read = item.data.read;
        read.consumption = 0;
        if (previousRead !== "") {
          read.consumption = parseFloat(read.read) - previousRead;
        }
        read.consumption = read.consumption.toFixed(2);

        newGraphs["read"].data.push(item.data.read);
        newGraphs["consumption"].data.push(read.consumption);
        graphDates.push(item.readDate);

        let itemKey = 0;
        Object.keys(item.data).forEach((key) => {
          read[fieldMap[key]] = item.data[key];
          itemKey = itemKey + 1;
          fieldMapCount[fieldMap[key]] ++;
        });

        data.push(read);

        previousRead = parseFloat(read.read);
      });

      data.reverse();

      let fieldCount = fields.length;
      while(fieldCount--) {
        let item = fields[fieldCount];
        if(typeof fieldMapCount[item.value] !== 'undefined' && fieldMapCount[item.value] === 0) {
          fields.splice(fieldCount, 1);
        }
      }

      this.readData = data;
      this.headers = fields;

      const min = new Date() - 5184000000;
      this.optionData.labels = graphDates;
      this.optionData.xaxis.max = new Date().getTime();
      this.optionData.xaxis.min = new Date(min).getTime();

      this.seriesData[0].data = newGraphs['read'].data;
      this.seriesData[1].data = newGraphs['consumption'].data;
    },
    loadGraph() {
      //let chart = am4core.create(this.$refs.chartdiv, am4charts.XYChart);

      // Create chart instance
      let chart = am4core.create(this.$refs.chartdiv, am4charts.XYChart);
      am4core.options.minPolylineStep = 5;

      // Increase contrast by taking evey second color
      chart.colors.step = 2;

      const meterData = this.meterData;

      // Add data
      chart.data = generateActualData();

      // Create axes

      let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
      //dateAxis.renderer.minGridDistance = 25;
      dateAxis.groupData = true;
      dateAxis.groupCount = 500;

      // Create series
      function createAxisAndSeries(field, name, opposite, bullet, isColumn) {
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

        let series = isColumn
          ? chart.series.push(new am4charts.ColumnSeries())
          : chart.series.push(new am4charts.LineSeries());

        series.dataFields.valueY = field;
        series.dataFields.dateX = "date";
        series.strokeWidth = 2;
        series.yAxis = valueAxis;
        series.name = name;
        series.tooltipText = "{name}: [bold]{valueY}[/]";
        series.tensionX = 0.8;
        series.minBulletDistance = 20;
        series.hiddenState.transitionDuration = 0;

        let interfaceColors = new am4core.InterfaceColorSet();

        bullet = series.bullets.push(new am4charts.CircleBullet());
        bullet.circle.stroke = interfaceColors.getFor("background");
        bullet.circle.strokeWidth = 2;

        valueAxis.renderer.line.strokeOpacity = 1;
        valueAxis.renderer.line.strokeWidth = 2;
        valueAxis.renderer.line.stroke = series.stroke;
        valueAxis.renderer.labels.template.fill = series.stroke;
        valueAxis.renderer.opposite = opposite;
        valueAxis.renderer.grid.template.disabled = true;

        let scrollbarX = new am4charts.XYChartScrollbar();
        scrollbarX.series.push(series);
        chart.scrollbarX = scrollbarX;
      }

      createAxisAndSeries("read", meterData.unit, false, "circle");
      createAxisAndSeries("consumption", "Consumption", true, "circle");

      // Add legend
      chart.legend = new am4charts.Legend();


      //chart.dateFormatter.dateFormat = "MM-dd";

      // Add cursor
      chart.cursor = new am4charts.XYCursor();

      function generateActualData() {
        let chartData = [];
        let previous = "";
        meterData.reads.forEach(function(row) {
          let entry = {
            date: new Date(row.readDate)
          };

          entry.read = row.data.read;

          entry.consumption = "";
          if (previous !== "") {
            entry.consumption = parseFloat(row.data.read) - previous;
            entry.consumption = entry.consumption.toFixed(2);
          }

          chartData.push(entry);
          previous = parseFloat(row.data.read);
        });
        return chartData;
      }

      chart.events.on("ready", function() {
        let d = new Date();
        d.setDate(d.getDate() - 14);
        dateAxis.zoomToDates(
          d,
          new Date(),
          false,
          true // this makes zoom instant
        );
      });

      this.chart = chart;
    }
  },

}
</script>

<style lang="scss" scoped>
.endpoint-overview {
  .v-card__subtitle {
    padding-bottom: 0px;
    text-transform: uppercase;
    color: rgba(255,255,255,0.8);
  }
  .v-card__title {
    padding-top: 5px;
    font-size: 1.6rem !important;

    &.smaller {
      font-size: 1.4rem !important;
    }
  }
}
.chart {
  width: 95%;
  height: 500px;
}

.supplyIcon {
  margin-top: -5px;
  position: relative;
}

.updated-date {
  color: rgba(255, 255, 255, 0.8);
  font-size: .8rem;
  line-height: .8rem;
  margin-top: 3px;
  margin-left: 15px;
}
</style>
